<template>
  <v-navigation-drawer
    v-if="getActive"
    v-model="barOpen"
    absolute
    hide-overlay
    right
    floating
    :width="barOpen ? 10000 : 0"
    disable-resize-watcher
  >
    <scroll-area>
      <template slot="header">
        <v-layout style="height: 40px" mb-2 mt-2 px-1>
          <div class="active cabinet_hide_button">           
            <div :class="cabinetShow ? 'white cabinet_hide_button_trigger_show' : 'white cabinet_hide_button_trigger_hide'" 
            :data-testid="$options.name + '__btn__' + 'cabinet_hide_button'"
            @click="() => onCabinetShow()">
              <v-tooltip v-if="cabinetShow" left color="primary">
                <v-icon v-if="cabinetShow" small color="lightgrey" slot="activator">navigate_before</v-icon>
                <span class="white--text">{{ $t('hide cabinet') }}</span>
              </v-tooltip>
              <v-tooltip v-if="!cabinetShow" right color="primary">
                <v-icon v-if="!cabinetShow" small color="lightgrey" slot="activator">navigate_next</v-icon>
                <span class="white--text">{{ $t('show cabinet') }}</span>
              </v-tooltip>
            </div>
          </div>    
          <v-layout fill-height class="title toolbar_castom">

            <v-layout v-if="getActive.cls == 'device'" align-center justify-start px-2>
              <span v-if="fields.form" class="uppercase body-1"> {{ $t('editing') }} - </span>
              <span v-if="getSelected && getSelected.cls != 'device'" class="uppercase body-1">{{ getActive.name }} / </span>
              <span v-if="getSelected && getSelected.cls != 'device' && getSelected.$parent" class="uppercase body-1">{{ getSelected.$parent.name }} / </span>
              <span class="uppercase body-1">{{ getSelected.name }}</span>
            </v-layout>

            <v-layout v-if="getActive.cls == 'module'" align-center justify-start px-2>
              <span v-if="fields.form" class="uppercase body-1"> {{ $t('editing') }} - </span>
              <span>{{ getSelected.name }}</span>
            </v-layout>

            <v-layout v-if="getActive.cls == 'unit'" align-center justify-start px-2>
              <span class="body-1">{{$t('add device into unit')}}: {{ getActive.position }}</span>
            </v-layout>

            <v-layout fill-height v-if="getActive.cls == 'unit' && !fields.form" justify-end align-center>
              <v-tooltip dark color="secondary" left>
                <v-btn icon flat slot="activator" 
                :data-testid="$options.name + '__btn__' + 'onDeviceBarClose'"
                @click="() => onDeviceBarClose()">
                  <svg-icon
                    :color="'grey'"
                    :name="'close'"
                    width="20"
                  />
                </v-btn>
                <span>{{ $t('cancel') }}</span>
              </v-tooltip>
            </v-layout>

            <v-layout fill-height v-if="fields.form && fields.create" justify-end align-center>
              <v-tooltip dark color="secondary" left>
                <v-btn icon flat slot="activator" 
                :data-testid="$options.name + '__btn__' + 'submit'"
                @click="() => submit()">
                  <svg-icon
                    :color="'grey'"
                    :name="'done'"
                    width="20"
                  />
                </v-btn>
                <span>{{ $t('add') }}</span>
              </v-tooltip>

              <v-tooltip dark color="secondary" left>
                <v-btn icon flat slot="activator" 
                :data-testid="$options.name + '__btn__' + 'cancel'"
                @click="() => onDeviceBarClose()">
                  <svg-icon
                    :color="'grey'"
                    :name="'close'"
                    width="20"
                  />
                </v-btn>
                <span>{{ $t('cancel') }}</span>
              </v-tooltip>
            </v-layout>

            <v-dialog v-if="(getActive.cls == 'device' || getActive.cls == 'module') && !fields.create" v-model="dialog.confirm" persistent max-width="290">
              <template v-slot:activator="{ on }">
                <v-layout fill-height justify-end align-center>
                  <v-tooltip v-if="!fields.form && !noclose" dark color="secondary" left>
                    <v-btn icon flat slot="activator" 
                    :data-testid="$options.name + '__dialog_btn__' + 'onDeviceBarClose'"
                    @click="() => onDeviceBarClose()">
                      <svg-icon
                        :color="'grey'"
                        :name="'close'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('close') }}</span>
                  </v-tooltip>

                  <v-tooltip v-if="fields.form" dark color="secondary" left>
                    <v-btn icon flat slot="activator" 
                    :data-testid="$options.name + '__dialog_btn__' + 'onFieldsFormClose'"
                    @click="() => onFieldsFormClose()">
                      <svg-icon
                        :color="'grey'"
                        :name="'close'"
                        width="20"
                      />
                    </v-btn>
                    <span>{{ $t('cancel') }}</span>
                  </v-tooltip>
                </v-layout>
              </template>

              <v-card>
                <v-card-title class="blue lighten-3 caption">
                  <v-layout fill-height justify-space-around>
                    <v-flex shrink class="uppercase">
                      {{$t('confirmation request')}}
                    </v-flex>
                  </v-layout>
                </v-card-title>

                <v-card-text>
                  <v-layout column align-center>
                    <v-flex pb-2>
                      <span class="uppercase">{{$t('remove')}}:</span>
                    </v-flex>
                    <span>"{{ getSelected.name }}"?</span>
                  </v-layout>
                </v-card-text>

                <v-card-actions>
                  <v-layout px-2>
                    <v-btn small block color="grey lighten-3" dark text 
                    :data-testid="$options.name + '__dialog_btn__' + 'no'"
                    @click="dialog.confirm = false">{{$t('no')}}</v-btn>

                    <v-btn small block color="error" text 
                    :data-testid="$options.name + '__dialog_btn__' + 'yes'"
                    @click="() => onDelete()">{{$t('yes')}}</v-btn>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-layout>
        </v-layout>
      </template>

      <template slot="body">
        <v-container fluid fill-height ma-0 pa-0 pb-2>
          <v-layout :column="getActive.cls != 'unit'" pa-0 ma-0>
            <v-flex xs12 v-if="getActive.cls == 'unit'">
              <v-layout fill-height pl-3>
                <component
                  is="choose-device"
                  :data="getActive"
                  @select="(payload) => onDeviceSelect(payload)"
                />
              </v-layout>
            </v-flex>
        
            <v-flex xs12>
              <v-layout column v-if="fields.create && fields.form" fill-height justify-start>
                <component
                  v-if="current.template"
                  is="form-fields"
                  ref="new-device-form"
                  :data="current.template"
                  :cabinet="getCabinet"
                  @update="() => onDeviceUpdate(payload)"
                />

              </v-layout>

              <v-layout column v-if="!fields.create && getActive.cls != 'unit'" fill-height justify-start >
                <v-layout v-if="!fields.form" column>
                  <component
                    is="show-fields"
                    :data="getSelected"
                    :current="getCurrent"
                    :cabinet="getCabinet"
                    :closedUnits="getClosedUnits"
                    @status="(payload) => checkStatus(payload)"
                    @edit="() => onFieldsFormOpen()"
                    @update="(payload) => onDeviceUpdate(payload)"
                    @deviceReplacingLoadDevices="() => onDeviceReplacingLoadDevices()"
                  />

                </v-layout>

                <v-layout v-if="fields.form" column>
                  <component
                    is="form-fields"
                    :data="getSelected"
                    :current="getCurrent"
                    :cabinet="getCabinet"
                    :closedUnits="getClosedUnits"
                    ref="new-device-form"
                    @close="() => onFieldsFormClose()"
                    @update="(payload) => onDeviceUpdate(payload)"
                  />
                </v-layout>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-dialog v-model="autodiscoverDialog" persistent max-width="600">
            <v-card style="height: 500px">
              <v-toolbar color="secondary" dense>
                <v-toolbar-title v-if="getActive.cls == 'device'">
                  <span v-if="fields.form" class="uppercase primary--text"> {{ $t('editing') }} - </span>
                  <span v-if="getSelected && getSelected.cls != 'device'">{{ getActive.name }} / </span>
                  <span>{{ getSelected.name }}</span>
                </v-toolbar-title>
              </v-toolbar>
              <v-card-title>
                <div style="display: flex; justify-content: space-between; flex-direction: row;">
                  <div style="border: 1px solid black; width: 260px; height: 370px; overflow-y: auto">
                    <template v-for="(module, index) in modules">
                      <div style="padding: 5px 5px; display: flex; justify-content: flex-start; flex-direction: row;">
                        <p style="width: 80px">
                          Слот: {{module.slot}}
                        </p>
                        <span>
                          {{module.module}}
                        </span>
                      </div>
                    </template>
                  </div>
                  <div style="width: 50px; margin:130px 0; display: flex; justify-content: center; flex-direction: column;">
                    <v-btn :data-testid="$options.name + 'v-btn' + 'cloneModules'" flat icon color="red" @click="cloneModules">
                      <v-icon>arrow_right_alt</v-icon>
                    </v-btn>
                  </div>
                  <div style="border: 1px solid black; width: 260px; height: 370px; overflow-y: auto">
                    <template v-for="(module, index) in activeModules">
                      <div style="padding: 5px 5px; display: flex; justify-content: flex-start; flex-direction: row; margin-block-end: 1px">
                        <p style="width: 80px;">
                          Слот: {{module.slot}}
                        </p>
                        <span>
                          {{module.module}}
                        </span>
                      </div>
                    </template>
                  </div>
                </div>
              </v-card-title>
              <v-card-actions>
                <v-layout px-2>
                  <v-btn small block color="grey lighten-3" dark text 
                  :data-testid="$options.name + '__autodiscoverDialog_btn__' + 'close'"
                  @click="autodiscoverDialog = false">{{$t('close')}}</v-btn>
                  <v-btn small block color="error" text 
                  :data-testid="$options.name + '__autodiscoverDialog_btn__' + 'Save'"
                  @click="() => saveModules()">{{$t('Save')}}</v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog.manualStatus.open" persistent max-width="600">
            <v-card style="height: 480px">
              <v-layout column fill-height>
                <scroll-area>
                  <template slot="header">
                    <v-toolbar dark color="secondary" dense>
                      <v-toolbar-title>
                        <span v-if="getSelected" class="body-2 text-uppercase">{{$t('manual change status of')}} {{getSelected.name}}</span>
                      </v-toolbar-title>
                    </v-toolbar>
                  </template>

                  <template slot="body">
                    <v-layout column justify-start pa-1>
                      <v-select
                        :data-testid="$options.name + '__select__' + 'status'"
                        v-model="dialog.manualStatus.status"
                        light
                        auto-grow
                        :items="['ok', 'maintenance', 'repairs', 'decommissioned']"
                        :label="$t('status')"
                        outline
                        hide-details
                        class="white"
                        color="primary"
                        background-color="white"
                        rows="1"
                        height="56"
                      >
                        <template v-slot:item="{ item }">
                            <span>{{ $t(item) }}</span>
                        </template>
                        <template v-slot:selection="{ item }">
                            <span>{{ $t(item) }}</span>
                        </template>
                    </v-select>

                      <v-textarea
                        :data-testid="$options.name + '__textarea__' + 'comment'"
                        v-model="dialog.manualStatus.comment"
                        :disabled="dialog.manualStatus.noComment"
                        light
                        auto-grow
                        outline
                        flat
                        :label="$t('comment')"
                        class="white"
                        hide-details
                        rows="3"
                      ></v-textarea>
                    </v-layout>
                  </template>

                  <template slot="footer">
                    <v-layout justify-end px-1>
                      <v-flex xs2 pa-1>
                        <v-btn small block color="grey lighten-3" dark text 
                        :data-testid="$options.name + '__btn__' + 'dialogChangeStatusManualClose'"
                        @click="dialogChangeStatusManualClose()">{{$t('cancel')}}</v-btn>
                      </v-flex>

                      <v-flex xs2 pa-1>
                        <v-btn small :disabled="!dialog.manualStatus.comment" block color="success lighten-2" text 
                        :data-testid="$options.name + '__btn__' + 'changeStatusManual'"
                        @click="changeStatusManual()">{{$t('change')}}</v-btn>
                      </v-flex>
                    </v-layout>
                  </template>
                </scroll-area>
              </v-layout>
            </v-card>
          </v-dialog>
        </v-container>
      </template>
    </scroll-area>
  </v-navigation-drawer>
</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import FormFields from '@/nms/pages/device/form/form-device-bar-fields.vue'
import ShowFields from '@/nms/pages/device/form/show-device-bar-fields.vue'
import ChooseDevice from '@/nms/pages/device/choose-device.vue'
import DeviceReplacing from '@/nms/pages/device/device-replace-choose.vue'
import DeviceCard from '@/nms/components/device/device-card.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'
import { mapGetters } from 'vuex'
import { CCMDBObject } from '@entcor/ebridge'

// Типы
interface ActiveModule {
  slot: string
  id: string
  module: string
  moduleId: string
  updated: boolean
}

interface ModuleItem {
  slot: string
  module: string
  [key: string]: any
}

interface DialogState {
  confirm: boolean
  manualStatus: {
    open: boolean
    status: string | null
    comment: string
    noComment: boolean
  }
}

interface ColorItem {
  color: string
  description: string
}

interface ColorsMap {
  [key: string]: ColorItem
}

interface CurrentState {
  side: string
  template: any | null
  parent: any | null
}

interface FieldsState {
  create: boolean
  form: boolean
}

interface MetaField {
  name: string
  polling?: string
  [key: string]: any
}

interface MetaData {
  fields?: MetaField[]
  [key: string]: any
}

interface DeviceData {
  $id?: string
  id?: string
  cls?: string
  name?: string
  template?: string
  device_type?: string
  children?: any[]
  position?: number
  mount?: string
  ip_address?: string
  [key: string]: any
}

interface CabinetData {
  $id?: string
  [key: string]: any
}

interface SelectedSlot {
  side?: string
  [key: string]: any
}

interface ScripterResponse {
  method?: string
  req?: {
    data?: { ip?: string }
    [key: string]: any
  }
  [key: string]: any
}

interface ScripterExecResponse {
  status?: string
  response?: string
  [key: string]: any
}

const fetchAsync = async (url: string): Promise<any> => {
  const response = await fetch(url)
  return await response.json()
}

const postData = async (url: string = '', data: any = {}): Promise<any> => {
  const response = await fetch(url, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(data)
  })
  return response.json()
}

const compare = (a: { slot: string }, b: { slot: string }): number => {
  if (parseInt(a.slot) > parseInt(b.slot)) return 1
  if (parseInt(b.slot) > parseInt(a.slot)) return -1
  return 0
}

export default Vue.extend({
  name: 'DEVICE_BAR',

  components: {
    scrollArea,
    FormFields,
    ShowFields,
    ChooseDevice,
    DeviceReplacing,
    DeviceCard,
    svgIcon
  },

  props: {
    open: {
      type: Boolean,
      default: () => false
    },
    noclose: {
      type: Boolean,
      default: () => false
    },
    fromTree: {
      type: Boolean,
      default: () => false
    },
    modalMode: {
      type: Boolean,
      default: () => false
    },
    modalActive: {
      type: Object as () => DeviceData,
      default: () => ({})
    },
    size: {
      type: Number,
      default: 1000
    },
    cabinet: {
      type: Object as () => CabinetData,
      default: () => ({})
    },
    cabinetShow: {
      type: Boolean,
      default: () => false
    },
    closedUnits: {
      type: Array as () => any[],
      default: () => []
    },
    selectedSlot: {
      type: Object as () => SelectedSlot,
      default: () => ({})
    },
  },

  data(): {
    activeModules: ActiveModule[]
    barOpen: boolean
    barSize: number
    dialog: DialogState
    autodiscoverDialog: boolean
    modules: ModuleItem[]
    meta: MetaData | null
    fields: FieldsState
    current: CurrentState
    color: ColorItem
    colors: ColorsMap
  } {
    return {
      activeModules: [],
      barOpen: false,
      barSize: 0,
      dialog: {
        confirm: false,
        manualStatus: {
          open: false,
          status: null,
          comment: '',
          noComment: false,
        },
      },
      autodiscoverDialog: false,
      modules: [],
      meta: null,
      fields: {
        create: false,
        form: false
      },
      current: {
        side: 'front',
        template: null,
        parent: null,
      },
      color: {
        color: '#7F7F7F',
        description: 'У объекта мониторинга отсутствует сетевая доступность'
      },
      colors: {},
    }
  },

  computed: {
    getSize(): number {
      return this.barSize
    },

    getCurrent(): CurrentState {
      return this.current
    },

    getCabinet(): CabinetData {
      return this.cabinet
    },

    getClosedUnits(): any[] {
      return this.closedUnits || []
    },

    getActive(): DeviceData | null {
      if (this.modalMode && this.modalActive) {
        return this.modalActive
      }
      return this.getActiveDevice
    },

    getSelected(): DeviceData | null {
      if (this.modalMode && this.modalActive) {
        return this.getSelectedItem || this.modalActive
      }
      return this.getSelectedItem || this.getActiveDevice
    },

    getMeta(): MetaData | null {
      return this.meta
    },

    ...mapGetters(['getActiveDevice', 'getSelectedItem', 'getTreeActive', 'checkPage', 'kiosk']),
  },

  watch: {
    open: {
      handler(newVal: boolean): void {
        const barWrapper = this.$parent.$refs?.['barWrapper'] as HTMLElement
        if (barWrapper) {
          this.barSize = barWrapper.clientWidth
        }
        this.barOpen = newVal
        this.$set(this.dialog, 'confirm', false)
        if (newVal) {
          this.$set(this.current, 'side', 'front')
        }
      },
      deep: true
    },
    size: {
      handler(newVal: number): void {
        this.barSize = newVal
      },
      deep: true
    },
    '$store.state.devices.activeDevice': {
      handler(newVal: DeviceData | null): void {
        if (this.modalMode) return
        console.log('WATCH', this.$options.name, '$store.state.devices.activeDevice', newVal)
        console.log('WATCH', this.$options.name, 'current.template', this.current.template)
        this.$set(this.dialog, 'confirm', false)
        this.reset()
        this.checkStatus(newVal)
        if (!newVal) {
          this.$bridge.offStream('device')
          this.$bridge.offStream('device_bar')
        }
      },
      deep: true
    },
  },

  created(): void {
    this.setup()
  },

  mounted(): void {
    document.addEventListener('keyup', this.closeOnESC)
    window.addEventListener('resize', this.resizeHandler)

    if (this.open) {
      const barWrapper = this.$parent.$refs?.['barWrapper'] as HTMLElement
      if (barWrapper) {
        this.barSize = barWrapper.clientWidth
      }
      this.barOpen = this.open
      this.$set(this.dialog, 'confirm', false)
      this.$set(this.current, 'side', 'front')
    }
  },

  beforeDestroy(): void {
    document.removeEventListener('keyup', this.closeOnESC)
    window.removeEventListener('resize', this.resizeHandler)
    if (!this.modalMode) {
      this.$store.dispatch('activeDevice', null)
    }
  },

  methods: {
    getModuleTemplate(module: any): string {
      if (module?.children?.length) {
        return module.children[0].template
      }
      return ''
    },

    getModuleId(module: any): string {
      if (module?.children?.length) {
        console.log(module.children[0].id)
        return module.children[0].$id
      }
      return ''
    },

    cloneModules(): void {
      this.activeModules = this.activeModules.map(module => {
        let newModule = ''
        for (let i = 0; i < this.modules.length; i++) {
          if (this.modules[i].slot === module.slot.toString()) {
            newModule = this.modules[i].module
            break
          }
        }
        return {
          ...module,
          module: newModule,
          updated: true
        }
      })
    },

    getActiveDeviceChildren(): ActiveModule[] {
      const active = this.getActive
      if (active?.children?.length) {
        return active.children.map(module => ({
          slot: module.ref_id,
          id: module.$id,
          module: this.getModuleTemplate(module),
          moduleId: this.getModuleId(module),
          updated: false
        }))
      }
      return []
    },

    async saveModules(): Promise<void> {
      for (const item of this.activeModules) {
        if (item.updated === true) {
          await this.$store.dispatch('updateDevice', {
            id: item.id,
            template: item.module === '' ? 'null' : item.module,
            moduleId: item.moduleId,
            name: `${item.module}_${item.slot}`
          })
        }
      }

      const query = {
        id: [this.getActive?.$id],
        notNull: true,
        data: { links: { flatten: false } }
      }
      const updatedDevice = await this.$bridge.cmdbQuery(query)
      this.$store.dispatch('activeDevice', updatedDevice[0])
      this.$emit('load-devices')
      this.autodiscoverDialog = false
    },

    async autodiscover(): Promise<void> {
      this.activeModules = this.getActiveDeviceChildren()
      const template = this.getActive?.template
      const url = this.$scripterURL + `/scripter/query?template=${template}`
      const result = await fetchAsync(encodeURI(url)) as ScripterResponse

      if (result.method === 'snmp' && result.req) {
        if (result.req.data) {
          result.req.data.ip = this.getActive?.ip_address
        }
        const urlExec = this.$scripterURL + '/scripter/exec'
        const resultExec = await postData(urlExec, result.req) as ScripterExecResponse

        if (resultExec.status === 'ok') {
          this.modules = JSON.parse(resultExec.response)
          this.modules.sort(compare)
        }
      }
      this.autodiscoverDialog = true
    },

    setup(): void {
      this.loadMeta()
      this.statusUnsubscribe('device_bar')
    },

    async loadMeta(): Promise<void> {
      try {
        this.setLoader('loadMeta', true)
        this.meta = await this.$loadMeta('device')
        this.setLoader('loadMeta', false)
      } catch (err) {
        console.error('CATCH', this.$options.name, 'loadMeta', err)
        this.setLoader('loadMeta', false)
      }
    },

    loadColors(): void {
      const statuses = this.$store.state.books.statuses
      if (statuses?.length) {
        this.colors = {}
        statuses.forEach((item: any) => {
          this.colors[item.name] = {
            color: item.back_color,
            description: item.description
          }
        })
      }
    },

    checkStatus(status: DeviceData | null): void {
      if (status?.state) {
        if (!Object.keys(this.colors).length) {
          this.loadColors()
        }
        this.color = this.colors[status.state.infoState] || {
          color: '#9F9F9F',
          description: 'У объекта мониторинга отсутствует сетевая доступность'
        }
      } else if (status?.$id) {
        this.getMirror(status)
      } else {
        this.color = {
          color: '#9F9F9F',
          description: 'У объекта мониторинга отсутствует сетевая доступность'
        }
      }
    },

    onDeviceSelect(data: DeviceData | null): void {
      if (!data) {
        this.reset()
        return
      }
      this.$set(this.fields, 'create', true)
      this.$set(this.fields, 'form', true)
      this.$set(this.current, 'template', data.template)
    },

    onDeviceBarClose(): void {
      this.$emit('showCabinet', true)
      this.$emit('close')
    },

    async onFieldsFormOpen(): Promise<void> {
      try {
        const id = this.getSelected?.$id
        if (id) {
          const block = await this.$store.dispatch('createDabLock', id)
          if (block?.ok) {
            this.$set(this.fields, 'form', true)
          } else {
            this.$errorHandler(block, 'DabLock')
          }
        } else {
          this.$set(this.fields, 'form', true)
        }
      } catch (err) {
        console.error('CATCH', 'DEVICE_BAR', 'onFieldsFormOpen', err)
      }
    },

    async onFieldsFormClose(): Promise<void> {
      const id = this.getSelected?.$id
      if (id) {
        await this.$store.dispatch('disposeDabLock', id)
      }
      this.fields.form = false
    },

    async onDeviceReplacingLoadDevices(): Promise<void> {
      this.$emit('load-devices')
      this.$emit('update')
    },

   onDeviceUpdate(val: DeviceData): void {
      const obj = val?.$id && val.cls === 'device' ? val : this.getSelected
      this.$emit('update', obj)
      this.$store.dispatch('selectItem', obj)
    },

    dialogChangeStatusManualClose(): void {
      this.$set(this.dialog, 'manualStatus', {
        open: false,
        status: null,
        comment: '',
        noComment: false,
      })
    },

    async changeStatusManual(): Promise<void> {
      try {
        const obj = await this.$bridge.getObjectById(this.getSelected?.$id)
        if (obj) {
          const state = this.dialog.manualStatus.status
          const message = this.dialog.manualStatus.comment
          await obj.updateState(state, message)
          this.color = this.colors[state as string]
          this.dialogChangeStatusManualClose()
        }
      } catch (err) {
        this.$errorHandler(err)
      }
    },

    async updateDevice(): Promise<void> {
      if (this.$store.state.auth.lock) return
      this.$store.state.auth.lock = true

      const valid = this.checkForm('new-device-form')
      console.log(this.$options.name, 'updateDevice', 'checkForm', valid)

      if (!valid?.valid) {
        this.$store.state.auth.lock = false
        return
      }

      try {
        const data_$ = Object.assign({}, valid.valid)
        const obj = await this.$bridge.getObjectById(valid.$id)
        const meta = await obj.meta() as MetaData

        const keys = Object.keys(data_$)
        const data$: Record<string, any> = {}
        keys.forEach(key => {
          data$[key] = data_$[key]
        })

        this.setLoader('updateDevice', true)
        let needPolling = false

        keys.forEach(key => {
          if (data_$[key] !== obj[key]) {
            const field = meta.fields?.find((f: MetaField) => f.name === key)
            if (field?.polling === 'true') {
              needPolling = true
            }
          }
        })

        if (obj) {
          if (data_$.position === 'out') {
            const query = {
              id: [this.getCabinet.$id],
              notNull: true,
              data: { parent: true }
            }
            const cab = await this.$bridge.cmdbQuery(query)
            const moved = await obj.move(cab[0].parent)
            if (moved) {
              this.fields.form = false
              console.log('Устройство перемещено')
            }
            this.$emit('load-devices')
            this.setLoader('updateDevice', false)
            this.$store.state.auth.lock = false
            return
          }

          if (obj.cls === 'device' && !valid.valid.mount) {
            data$.mount = (this.selectedSlot as SelectedSlot).side
          }

          const u = await obj.update(data$)
          console.log(this.$options.name, 'updateDevice', 'response', u)

          if (u) {
            this.$dialog.notify.success('Успешно обновлено', { timeout: 5000 })
            await this.$store.dispatch('updateObject', { $id: u.$id })

            if (u.cls === 'device') {
              const query = {
                id: [this.getActive?.$id],
                notNull: true,
                data: { links: { flatten: false } }
              }
              const updatedDevice = await this.$bridge.cmdbQuery(query)
              this.$emit('update', updatedDevice[0])
              this.initPolling(updatedDevice[0])
            } else {
              this.$store.dispatch('selectItem', u)
              this.fields.form = false
              this.initPolling(u)
            }
          } else {
            this.$dialog.notify.success('Ошибка обновления', { timeout: 5000 })
          }
        }

        this.setLoader('updateDevice', false)
        this.$store.state.auth.lock = false
      } catch (err) {
        console.error('CATCH', this.$options.name, 'update', err)
        this.setLoader('updateDevice', false)
        this.$store.state.auth.lock = false
        this.$errorHandler(err)
      }
    },

    checkForm(name: string): any {
      const ref = this.$refs[name] as any
      return ref ? ref.validateForm() : false
    },

    async submit(): Promise<void> {
      if (this.$store.state.auth.lock) return
      this.$store.state.auth.lock = true

      const valid = this.checkForm('new-device-form')
      if (!valid?.valid) {
        this.$store.state.auth.lock = false
        return
      }

      try {

        const parentId = this.current.parent || this.cabinet.$id
        const $parent = await this.$bridge.getObjectById(parentId)
        const cls = this.current.template.cls || 'device'
        const data_$ = Object.assign({}, valid.valid)
        data_$.template = this.current.template.id
        data_$.device_type = this.current.template.device_type
        data_$.position = this.getActive?.position

        
        if (!valid.valid.mount) {
          data_$.mount = cls === 'device' ? (this.selectedSlot as SelectedSlot).side : $parent.side
        }

        const keys = Object.keys(data_$)
        const data$: Record<string, any> = {}
        keys.forEach(key => {
          data$[key] = data_$[key]
        })

        this.setLoader('submitDevice', true)
        const c = await $parent.createChild(cls, data$)
        console.log(this.$options.name, 'submit', 'response', c)

        if (c) {
          this.$dialog.notify.success('Успешно создано', { timeout: 5000 })
          await this.$store.dispatch('updateObject', { $id: c.$id })

          const query = {
            id: [this.getActive?.$id || c.$id],
            notNull: true,
            data: { links: { flatten: false } }
          }
          const updatedDevice = await this.$bridge.cmdbQuery(query)
          await this.$bridge.subscribe([updatedDevice[0].$id])
          this.$emit('update', updatedDevice[0])
        }

        this.setLoader('submitDevice', false)
        this.$store.state.auth.lock = false
      } catch (err) {
        console.error('CATCH', this.$options.name, 'submit!!!!', err)
        this.setLoader('submitDevice', false)
        this.$store.state.auth.lock = false
        this.$errorHandler(err)
      }
    },

    onCabinetShow(): void {
      this.$emit('showCabinet', !this.cabinetShow)
    },

    async onDelete(): Promise<void> {
      if (this.$store.state.auth.lock) return
      this.$store.state.auth.lock = true

      try {
        const obj = await this.$bridge.getObjectById(this.getSelected?.$id)
        const parent = await obj.getParent()
        this.dialog.confirm = false
        this.setLoader('deleteDevice', true)
        const d = await obj.delete()

        if (d) {
          this.$dialog.notify.success(this.$getTranslate('removal success'), { timeout: 5000 })

          if (d.cls === 'device') {
            if (parent.cls === 'location') {
              this.$store.dispatch('activeTree', parent)
            }
            if (parent.cls === 'cabinet' && this.kiosk) {
              await this.$store.dispatch('activeSidebar', parent.cls)
              await this.$store.dispatch('activeTree', parent)
              this.$router.push({ name: 'topology_cabinet' })
            }
            this.$emit('update', null)
          } else {
            this.$store.dispatch('selectItem', null)
            const query = {
              id: [this.getActive?.$id],
              notNull: true,
              data: { links: { flatten: false } }
            }
            const updatedDevice = await this.$bridge.cmdbQuery(query)
            this.$emit('update', updatedDevice[0])
          }
        } else {
          this.$dialog.notify.success('Ошибка удаления', { timeout: 5000 })
          console.log(this.getSelected?.$id, 'CAN NOT BE DELETED', d)
        }

        this.setLoader('deleteDevice', false)
        this.$store.state.auth.lock = false
      } catch (err) {
        console.log('onDelete', this.getSelected?.$id, 'SMTH BAD', err)
        this.$errorHandler(err)
        this.setLoader('deleteDevice', false)
        this.$store.state.auth.lock = false
      }
    },

    async statusSubscribe(group: string, arr: string): Promise<void> {
      this.$store.dispatch('measuresSubscribeInit', {
        name: 'addStatus',
        group: group,
        listener: 'status'
      })
      await this.$bridge.subscribe([arr])
    },

    subscribeHandler(e: { $id?: string; [key: string]: any }): void {
      if (this.getActive && e.$id === this.getActive.$id) {
        this.checkStatus(e as DeviceData)
      }
    },

    statusUnsubscribe(group: string): void {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: group,
        listener: 'status'
      })
    },

    async getMirror(obj: DeviceData): Promise<void> {
      try {
        const device = await this.$bridge.getObjectById(obj.$id)
        const mirror = await device.getMirror()

        if (mirror?.state) {
          if (!Object.keys(this.colors).length) {
            this.loadColors()
          }
          this.color = this.colors[mirror.state.infoState] || {
            color: '#9F9F9F',
            description: 'У объекта мониторинга отсутствует сетевая доступность'
          }
        }
      } catch (error) {
        console.error(this.$options.name, 'getMirror', 'error', error)
      }
    },

    async initPolling(obj: DeviceData): Promise<void> {
      console.log(this.$options.name, 'initPolling START', obj)
      try {
        await obj.initPolling()
        await this.statusSubscribe('device_bar', obj.$id || '')
      } catch (err) {
        console.error(this.$options.name, 'initPolling', 'WRONG', err)
        this.$errorHandler(err)
      }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    reset(): void {
      this.$store.dispatch('selectItem', null)
      this.fields.create = false
      this.fields.form = false
      this.current.template = null
      this.current.parent = null
    },

    closeOnESC(e: KeyboardEvent): void {
      if (this.noclose) return
      if (e.which === 27 || e.keyCode === 27) {
        e.stopPropagation()
        if (this.fields.form) {
          this.fields.form = false
        }
      }
    },

    resizeHandler(): void {
      const barWrapper = this.$parent.$refs?.['barWrapper'] as HTMLElement
      if (barWrapper) {
        this.barSize = barWrapper.clientWidth
      }
    },
  },
})
</script>

<style lang="css" scoped>

  .toolbar_castom {
    border: solid 1px #9F9F9F ;
    border-radius: 2px;
  }

  .cabinet_hide_button {
  position: relative;
  height: 40px;
  width: 40px;
  margin-right: 4px;
  margin-left: 12px;
  border: solid 1px #9F9F9F !important;
  border-radius: 2px;
}

.cabinet_hide_button_trigger_hide {
  position: absolute;
  height: 38px;
  width: 36px;
  border-left: solid 1px #9F9F9F !important;
  border-right: solid 1px #9F9F9F !important;
  padding-top: 8px;
  padding-left: 10px;
  left: 4px;
  border-radius: 2px;
}

.cabinet_hide_button_trigger_show {
  position: absolute;
  height: 38px;
  width: 26px;
  border-left: solid 1px #9F9F9F !important;
  border-right: solid 1px #9F9F9F !important;
  padding-top: 8px;
  padding-left: 4px;
  left: 14px;
  border-radius: 2px;
}

</style>
